// extracted by mini-css-extract-plugin
export default {"Title":"InsuranceSuccess_Title__KJmVX","Container":"InsuranceSuccess_Container__o0xz+","DownloadInfo":"InsuranceSuccess_DownloadInfo__-KJw1"};